import { RouteConfig } from 'vue-router';
import { requireProvider } from '@/router/guards/authGuards';
import { checkSitterOnboarding } from '@/router/guards/completionGuards';
import combineGuards from '@/router/guards/helpers';

const reviewRoutes: RouteConfig[] = [
  {
    path: '/provider/reviews/reply',
    name: 'ReviewReply',
    component: () => import('@/apps/provider/reviews/reply/ReviewReply.vue'),
    beforeEnter: combineGuards([requireProvider, checkSitterOnboarding]),
  },
  {
    path: '/provider/reviews/request',
    name: 'RequestTabs',
    component: () => import('@/apps/provider/request_reviews/request_tabs/RequestTabs.vue'),
    beforeEnter: combineGuards([requireProvider, checkSitterOnboarding]),
  },
  {
    path: '/provider/reviews/request/sent',
    name: 'RequestSent',
    component: () => import('@/apps/provider/request_reviews/request_sent/RequestSent.vue'),
    beforeEnter: combineGuards([requireProvider, checkSitterOnboarding]),
  },
];

export default reviewRoutes;
